import { useStickyElementsHeight } from "./StickyElementsHeight";

const AnchorTarget = ({ id, disableTopOffset = false }) => {
  // We use the stickyElementsHeight to calculate the offset of the anchor to allow the
  // scroll manager to scroll to the correct position when the page is loaded.
  const stickyElementsHeight = useStickyElementsHeight();
  const anchorTopOffset = disableTopOffset ? 0 : `-${stickyElementsHeight}px`;

  return <span id={id} className="anchor-target" style={{ top: anchorTopOffset }} />;
};

export default AnchorTarget;
